module.exports = __webpack_public_path__ + "img/icon1.a9c7552f.png";